import { useState, useEffect, useCallback } from "react";
import { API, AUTH, toLocalDateStr, exportXLSX } from "../../adminUtils";
import ExportBar from "./ExportBar";

export default function WorkshopRevenueReport() {
  const today = toLocalDateStr(new Date());
  const [from, setFrom]       = useState(() => { const d = new Date(); d.setDate(1); return toLocalDateStr(d); });
  const [to, setTo]           = useState(today);
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch_ = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API}/reports/workshop-revenue?from=${from}&to=${to}`, { headers: AUTH });
      const json = await res.json();
      setData(json);
    } catch { setData(null); }
    finally   { setLoading(false); }
  }, [from, to]);

  useEffect(() => { fetch_(); }, [fetch_]);

  const doExport = () => {
    if (!data?.workshops) return;
    const rows = [];
    for (const w of data.workshops) {
      for (const s of w.sessions) {
        rows.push({ Workshop: w.title, Session: s.label, Time: s.time, Bookings: s.bookings });
      }
      rows.push({ Workshop: w.title, Session: "TOTAL", Bookings: w.bookings });
    }
    exportXLSX("Workshop Revenue", rows, `iy-sp-workshops-${from}-${to}.xlsx`);
  };

  return (
    <div>
      <div className="adm-report-filters">
        <div className="adm-filter-group">
          <label className="adm-filter-label">From</label>
          <input type="date" className="adm-input" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div className="adm-filter-group">
          <label className="adm-filter-label">To</label>
          <input type="date" className="adm-input" value={to} max={today} onChange={e => setTo(e.target.value)} />
        </div>
      </div>
      {loading && <p className="adm-loading">Loading…</p>}
      {data && !loading && (
        <>
          <ExportBar onXLSX={doExport} />
          {data.workshops.length === 0
            ? <p className="adm-empty">No workshops in this period.</p>
            : data.workshops.map((w, i) => (
                <div key={i} className="adm-report-teacher">
                  <div className="adm-report-teacher-header">
                    <span className="adm-report-teacher-name">{w.title}</span>
                    <span className="adm-report-teacher-rate">{w.bookings} bookings</span>
                  </div>
                  <table className="adm-report-table">
                    <thead><tr><th>Session</th><th>Time</th><th>Bookings</th></tr></thead>
                    <tbody>
                      {w.sessions.map((s, j) => (
                        <tr key={j}><td>{s.label}</td><td>{s.time}</td><td>{s.bookings}</td></tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="adm-report-subtotal"><td colSpan={2}>Total bookings</td><td>{w.bookings}</td></tr>
                    </tfoot>
                  </table>
                </div>
              ))
          }
        </>
      )}
    </div>
  );
}